import React from "react";
import { Page, Image, Text, View, Document, StyleSheet, Font } from '@react-pdf/renderer';
import moment from "moment";

const styles = StyleSheet.create({
  page: {
    padding: 20,
  },
  title:{
    fontFamily: 'Helvetica-Bold',
    fontSize:'11px',
    fontWeight: "bold",
  },
  address: {
    fontSize: "10px"
  },  
  taxInvoice: {
    fontSize: "14px"
  },
  logo: {
    width: 160,
    height: 110
  },
  subtitle: {
    color: "#34556f",
  },
  section:{
    flexGrow:0,
    flexDirection:'row'
  },
  table: {
    width: '100%',
    borderBottom: "1px solid #34556f"
  },
  text:{
    fontSize:'11px',
    marginBottom:'5px',
    fontFamily: 'Helvetica'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 8,
    paddingBottom: 8,
    fontSize:'10px',
  },
  header: {
    fontSize:'10px',
    backgroundColor:'#989898',
    fontFamily: 'Helvetica-Bold',
  },
  whiteColor: {
    color: "#ffffff"
  },
  flex:{
    flexGrow:0,
    flexDirection:'row',
    height:'auto',
  },
  block: {
    display: "block"
  },
  bold: {
    fontFamily: 'Helvetica-Bold',
    fontWeight: 'bold',
  },
  session1:{
    width:'60%',
  },
  session2:{
    width:'40%',
  },
  row1: {
    width: '40%',
    marginLeft:'10px',
    marginRight: "10px"
  },
  row2: {
    width: '15%',
    marginLeft:'10px',
    marginRight: "10px"
  },
  row3: {
    width: '15%',
    marginLeft:'10px',
    marginRight: "10px"
  },
  row4: {
    width: '15%',
    marginLeft:'10px',
    marginRight: "10px"
  },
  rowBig: {
    width: '70%',
  },
  rowSmall: {
    width: '30%',
  },
  rowHalf1: {
    width: '60%',
    marginLeft:'10px'
  },
  rowHalf2: {
    width: '40%',
    marginLeft:'10px'
  },
  noPdBot: {
    paddingBottom: "0px"
  },
  noBorder: {
    border: "0px"
  },
  textRight: {
    textAlign: "right"
  },
  labelText: {
    width: "60px"
  }
});

export default function({
  products,
  templates,
}) {
  const dataTemplate = templates?.length > 0 ? templates[0] : {};
  return (
    <Document>
      <Page break={true} size={dataTemplate?.size ?? "A5"} style={{...styles.page}}>
        <View>
          <Text style={{...styles.text, ...styles.bold}}>{dataTemplate?.template ?? ""}</Text>
          {
            products?.filter(x => x.typeDrug === "external")?.map((product, index) => {
              return (
                <Text key={index} style={styles.text}>{product.name} - {`${product.qty} Qty`}</Text>
              )
            })
          }
        </View>
      </Page>
    </Document>
  )
}